var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 36 36",
    stroke: "#C4C4C4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.636v22.546l9.864-5.636 11.272 5.636L33 24.546V2l-9.864 5.636L11.864 2 2 7.636Z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.864 2v22.546M23.136 7.636v22.546",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMap;